import { UserRole } from 'gql/types';

const {
  Admin,
  Operations,
  RegionalUser,
  MedicalDirector,
  Dvm,
  Phlebotomist,
  TeamLead,
  CanineHandler,
} = UserRole;

export const INTERNAL_TEAM_ROLES = [
  Admin,
  MedicalDirector,
  Dvm,
  Operations,
  RegionalUser,
  Phlebotomist,
  CanineHandler,
  TeamLead,
];

export const ALLOWED_SIGNS = ",`()'";
